import { render, staticRenderFns } from "./dialog-box.component.vue?vue&type=template&id=fa40df30&scoped=true&"
import script from "./dialog-box.component.vue?vue&type=script&lang=js&"
export * from "./dialog-box.component.vue?vue&type=script&lang=js&"
import style0 from "./dialog-box.component.vue?vue&type=style&index=0&id=fa40df30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa40df30",
  null
  
)

export default component.exports